import styled, { css } from 'styled-components';
import { theme } from '../../../../theme';

const { filters } = theme;

export const LabelCheckbox = styled.label<{ isCheckboxList: boolean }>`
  ${(props) =>
    props &&
    css`
      &.filter-checkbox-label {
        position: relative;
        display: block;
        margin-bottom: 7px;
        padding-left: ${props.isCheckboxList ? '30px' : '35px'};
        padding-top: 2px;
        font-size: 10.8px;
        font-weight: 500;
        text-align: left;
        cursor: pointer;
        transition: all 0.3s ease;
      }
    `};
`;

export const SpanCheckbox = styled.span<{ isCheckboxList: boolean }>`
  ${(props) =>
    props &&
    css`
      position: absolute;
      top: 1px;
      left: ${props.isCheckboxList ? '5px' : '10px'};
      height: 16px;
      width: 16px;
      border: 1px solid ${filters.inputFieldHint};
      background: none;

      &::after {
        border: solid ${filters.checkboxMark};
        content: '';
        position: absolute;
        display: none;
        top: 50%;
        left: 50%;
        margin-left: -2px;
        margin-top: -6px;
        width: 5px;
        height: 10px;
        border-width: 0 2px 2px 0 !important;
        transform: rotate(45deg);
      }
    `};
`;

export const InputCheckbox = styled.input`
  position: absolute;
  z-index: -1;
  opacity: 0;

  &:checked ~ ${SpanCheckbox} {
    &::after {
      display: block;
    }
  }
`;
